<div class="patient-history">
  <h1 style="text-align: center;">Patient : Historique</h1>
  <button class="btn btn-primary" (click)="print()" id="print-button">
    Imprimer
  </button>
  <div class="flex" *ngIf="pdfViewSettings.antecedant">
    <h4 class="title">Patient Antécédent</h4>
    <input type="checkbox" [(ngModel)]="pdfViewSettings.antecedant" />
  </div>

  <div class="h-list">
    <ng-container *ngIf="doctorPatientAntecedents && antcedents.length; else empty">
      <div *ngFor="let patientAntecedent of antcedents" class="antecedent-card">
        <h4 class="label">{{patientAntecedent.label}}</h4>
        <textarea
          class="textarea"
          [value]="patientAntecedent.text"
          disabled
        ></textarea>
      </div>
    </ng-container>
    <ng-template #empty>
      <span>Aucun antecedant</span>
    </ng-template>
  </div>
  
  <div *ngFor="let patientHistoric of patientHistorics; let i = index" class="historique">
    <div class="content">
      <div class="flex">
        <h4 class="title">
          Date rdv : {{ patientHistoric.date | date:'dd/MM/yyyy' }}
        </h4>
        <input type="checkbox" [(ngModel)]="pdfViewSettings.Rdv[i]" />
      </div>

      <div class="flex" *ngIf="patientHistoric.motif">
        <p><strong>Motif:</strong> {{ patientHistoric.motif }}</p>
        <input type="checkbox" [(ngModel)]="pdfViewSettings.motif[i]" />
      </div>

      <div class="flex" *ngIf="patientHistoric.examenClinique">
        <p><strong>Examen Clinique:</strong>{{patientHistoric.examenClinique}}</p>
        <input type="checkbox" [(ngModel)]="pdfViewSettings.examenClinique[i]" />
      </div>

      <div class="flex" *ngIf="patientHistoric.histoireMaladie">
        <p><strong>Histoire de maladie:</strong>{{patientHistoric.histoireMaladie}}</p>
        <input type="checkbox" [(ngModel)]="pdfViewSettings.examenDemande[i]" />
      </div>

      <div class="flex" *ngIf="patientHistoric.diagnostic">
        <p><strong>Diagnostic:</strong> {{ patientHistoric.diagnostic }}</p>
        <input type="checkbox" [(ngModel)]="pdfViewSettings.diagnostic[i]" />
      </div>

      <!-- Consultation card view -->
      <div *ngIf="patientHistoric.hasConsultation">
        <h2>Consultation</h2>
        <ul>
          <!-- Radiologies -->
          <li *ngIf="patientHistoric.consultationRadiologies.length">
            <div class="flex">
              <strong>Radiologies:</strong>
              <input type="checkbox" [(ngModel)]="pdfViewSettings.radioConsultation[i]" />
            </div>
            <ul>
              <li *ngFor="let consultationRadiologie of patientHistoric.consultationRadiologies">
                {{ consultationRadiologie.radio.nom_Radio }} - {{ consultationRadiologie.note_consultation_radio }}
              </li>
            </ul>
          </li>

          <!-- Biologies -->
          <li *ngIf="patientHistoric.consultationBiologies.length">
            <div class="flex">
              <strong>Biologies:</strong>
              <input type="checkbox" [(ngModel)]="pdfViewSettings.biologieConsultation[i]" />
            </div>
            <ul>
              <li *ngFor="let consultationBiologie of patientHistoric.consultationBiologies">
                {{ consultationBiologie.biology.element_Bio }} - {{ consultationBiologie.value }} - {{ consultationBiologie.note }}
              </li>
            </ul>
          </li>

          <!-- Actes -->
          <li *ngIf="patientHistoric.consultationActes.length > 0">
            <div class="flex">
              <strong>Actes:</strong>
              <input type="checkbox" [(ngModel)]="pdfViewSettings.actes[i]" />
            </div>
            <ul>
              <li *ngFor="let consultationActe of patientHistoric.consultationActes">
                {{ consultationActe.act.desc_Acte }} 
                <span *ngIf="doctor.dashboardPrintPayments">- {{ consultationActe.montant_consultation_acte }} DT</span>
                - {{ consultationActe.note }}
              </li>
            </ul>
          </li>

          <!-- Vaccinations -->
          <li *ngIf="patientHistoric.consultationVaccinations.length">
            <div class="flex">
              <strong>Vaccins:</strong>
              <input type="checkbox" [(ngModel)]="pdfViewSettings.vaccin[i]" />
            </div>
            <ul>
              <li *ngFor="let consultationVaccination of patientHistoric.consultationVaccinations">
                {{ consultationVaccination?.prescription_consultation_vaccin?.nom_Vaccin }} - 
                Lot: {{ consultationVaccination?.numLot_consultation_vaccin }} - 
                Date: {{ consultationVaccination?.date_consultation_vaccin | date:'dd/MM/yyyy' }} - 
                {{ consultationVaccination?.note_consultation_vaccin }}
              </li>
            </ul>
          </li>
        </ul>
      </div>

      <!-- Lunette Ophtalmologie -->
      <div *ngIf="doctor.speciality.label == 'Ophtalmologue'" style="margin-bottom: 10px;">
        <div class="flex">
          <h2 class="tree-nav-item-title">Lunette</h2>
          <input type="checkbox" [(ngModel)]="pdfViewSettings.lunette[i]" />
        </div>
        <div style="display: flex; flex-direction: row; gap: 15px;">
          <div>
            <h4 style="font-family: 'Gotham Rounded Bold';">OD</h4>
            <div style="display: flex; flex-direction: row;">
              <h4 style="margin-left: 15px;"><strong>VL:</strong> {{patientHistoric.od_vl_avac_Sphere}} ({{patientHistoric.od_vl_avac_Cylindre}}) {{patientHistoric.od_vl_avac_Axe}}°</h4>
              <h4 style="margin-left: 15px;"><strong>VP:</strong> {{patientHistoric.od_vp_avac_Sphere}} ({{patientHistoric.od_vp_avac_Cylindre}}) {{patientHistoric.od_vp_avac_Axe}}°</h4>
            </div>
          </div>
          <div>
            <h4 style="font-family: 'Gotham Rounded Bold';">OG</h4>
            <div style="display: flex; flex-direction: row;">
              <h4 style="margin-left: 15px;"><strong>VL:</strong> {{patientHistoric.og_vl_avac_Sphere}} ({{patientHistoric.og_vl_avac_Cylindre}}) {{patientHistoric.og_vl_avac_Axe}}°</h4>
              <h4 style="margin-left: 15px;"><strong>VP:</strong> {{patientHistoric.og_vp_avac_Sphere}} ({{patientHistoric.og_vp_avac_Cylindre}}) {{patientHistoric.og_vp_avac_Axe}}°</h4>
              <span>Add:{{patientHistoric.og_vp_avac_Addition}}</span>
            </div>
          </div>
        </div>
        <span style="font-family: 'Gotham Rounded Bold'; text-align: center; justify-content: center; display: flex;">
          Note Lunette : {{patientHistoric.lunette_remarque}}
        </span>
      </div>

      <!-- Lentille Ophtalmologie -->
      <div *ngIf="doctor.speciality.label == 'Ophtalmologue'" style="margin-bottom: 10px;">
        <div class="flex">
          <h2 class="tree-nav-item-title">Lentille</h2>
          <input type="checkbox" [(ngModel)]="pdfViewSettings.lentille[i]" />
        </div>
        <div class="row">
          <div class="col-lg-6">
            <h4 style="font-family: 'Gotham Rounded Bold';">OG</h4>
            <Label class="mx-3">RC:{{patientHistoric.og_lentille_RC}}</Label>
            <Label>DC:{{patientHistoric.og_lentille_DC}}</Label>
            <Label class="mx-3">Puissance:{{patientHistoric.og_lentille_Puissance}}</Label>
          </div>
          <div class="col-lg-6">
            <h4 style="font-family: 'Gotham Rounded Bold';">OD</h4>
            <Label class="mx-3">RC:{{patientHistoric.od_lentille_RC}}</Label>
            <Label>DC:{{patientHistoric.od_lentille_DC}}</Label>
            <Label class="mx-3">Puissance:{{patientHistoric.od_lentille_Puissance}}</Label>
          </div>
          <span style="font-family: 'Gotham Rounded Bold'; text-align: center; justify-content: center;">
            Note Lentille : {{patientHistoric.lentille_remarque}}
          </span>
        </div>
      </div>

      <!-- Paramètres Santé -->
 <!-- Paramètres Santé -->
<div *ngIf="patientHistoric.consultationParamSanteValues?.length" class="tree-nav-item is-expandable">
  <div class="flex">
    <h2 class="tree-nav-item-title">Paramètres Santé</h2>
    <input type="checkbox" [(ngModel)]="pdfViewSettings.parametreSante[i]" />
  </div>

  <div class="tree-nav-item">
    <ul style="width: 100%;">
      <li *ngFor="let consultationParamSante of patientHistoric.consultationParamSanteValues">

        <!-- Médecin non ophtalmologue -->
        <ng-container *ngIf="doctor.speciality.label !== 'Ophtalmologue'
          && consultationParamSante.value != null
          && consultationParamSante.value !== ''">

          <strong>{{consultationParamSante.parametre?.label}}:</strong>
          <span>{{consultationParamSante.value}}</span>
        </ng-container>

        <!-- Ophtalmologue -->
        <ng-container *ngIf="doctor.speciality.label === 'Ophtalmologue'
          && (consultationParamSante.value_OG != null || consultationParamSante.value_OD != null)">

          <strong>{{consultationParamSante.parametre?.label}}:</strong>

          <span *ngIf="consultationParamSante.value_OG != null">
            OG: {{consultationParamSante.value_OG}}
          </span>

          <span *ngIf="consultationParamSante.value_OD != null">
            OD: {{consultationParamSante.value_OD}}
          </span>
        </ng-container>

      </li>
    </ul>
  </div>
</div>

      <!-- Prescription -->
      <div *ngIf="patientHistoric.hasPrescription">
        <h2>Prescription</h2>
        <ul>
          <!-- Medications -->
          <li *ngIf="patientHistoric.prescriptionMedics.length">
            <div class="flex">
              <strong>Médications:</strong>
              <input type="checkbox" [(ngModel)]="pdfViewSettings.medics[i]" />
            </div>
            <ul>
              <li *ngFor="let prescriptionMedic of patientHistoric.prescriptionMedics">
                {{ prescriptionMedic.medic.nom }} - {{ prescriptionMedic.posology }} - {{ prescriptionMedic.duration }} - {{ prescriptionMedic.note }}
              </li>
            </ul>
          </li>

          <!-- Radiologies -->
          <li *ngIf="patientHistoric.prescriptionRadiologies.length">
            <div class="flex">
              <strong>Radiologies:</strong>
              <input type="checkbox" [(ngModel)]="pdfViewSettings.radioPres[i]" />
            </div>
            <ul>
              <li *ngFor="let prescriptionRadiologie of patientHistoric.prescriptionRadiologies">
                {{ prescriptionRadiologie.radio.nom_Radio }} - {{ prescriptionRadiologie.note }}
              </li>
            </ul>
          </li>

          <!-- Biologies -->
          <li *ngIf="patientHistoric.prescriptionBiologies.length">
            <div class="flex">
              <strong>Biologies:</strong>
              <input type="checkbox" [(ngModel)]="pdfViewSettings.biologiePresc[i]" />
            </div>
            <ul>
              <li *ngFor="let prescriptionBiologie of patientHistoric.prescriptionBiologies">
                {{ prescriptionBiologie.biology.element_Bio }} - {{ prescriptionBiologie.note }}
              </li>
            </ul>
          </li>
        </ul>
      </div>
    </div>
  </div>
</div>

<div style="visibility: hidden;">
  <div id="pdf">
    <div class="page-header">
      <table class="table tst" cellspacing="0">
        <tr class="noborder">
          <td class="noborder name" style="text-align: left;">
            <span style="font-size: 17px;">{{doctor.printFullName}}</span>
          </td>
          <td class="docStyle name-arbic noborder">
            <span style="font-size: 20px;">{{doctor.printArabicFullName}}</span>
          </td>
        </tr>
        <tr class="noborder">
          <td class="font noborder">
            <span style="font-size: 14px;">{{doctor.printSpeciality}}</span>
          </td>
          <td class="docStyle font noborder">
            <span style="font-size: 14px;">{{doctor.printArabicSpeciality}}</span>
          </td>
        </tr>
        <tr class="noborder">
          <td class="font noborder">
            <span style="font-size: 14px;">{{doctor.fixPhone}}</span>
          </td>
          <td class="docStyle font noborder" style="left: 50%;">
            <span style="font-size: 14px;">{{doctor.fixPhone}}</span>
          </td>
        </tr>
        <tr class="font noborder" style="font-size: 11px;">
          <span>Code CNAM: {{doctor.cnam}}</span>
        </tr>
      </table>
    </div>
    
    <table>
      <thead>
        <tr>
          <td>
            <div class="page-header-space"></div>
          </td>
        </tr>
      </thead>
      <tbody>
        <tr>
          <td>
            <div class="content">
              <!-- Antécédents -->
              <div *ngIf="pdfViewSettings.antecedant && antcedents.length">
                <h5 class="label">Antécédents</h5>
                <ul>
                  <li *ngFor="let patientAntecedent of antcedents">
                    <strong>{{patientAntecedent.label}}:</strong> {{patientAntecedent.text}}
                  </li>
                </ul>
              </div>

              <!-- Historiques -->
              <div *ngFor="let patientHistoric of patientHistorics; let i = index">
                <div *ngIf="pdfViewSettings.Rdv[i] && patientHistoric">
                  <div class="row">
                    <div class="col-lg-6">
                      <h5 class="title">Date rdv : {{ patientHistoric.date | date:'dd/MM/yyyy' }}</h5>
                    </div>
                    <div class="col-lg-6">
                      <p *ngIf="pdfViewSettings.motif[i] && patientHistoric.motif">
                        <strong>Motif:</strong> {{ patientHistoric.motif }}
                      </p>
                    </div>
                  </div>
                  
                  <p *ngIf="pdfViewSettings.diagnostic[i] && patientHistoric.diagnostic">
                    <strong>Diagnostic:</strong> {{ patientHistoric.diagnostic }}
                  </p>
                  
                  <p *ngIf="pdfViewSettings.examenDemande[i] && patientHistoric.histoireMaladie">
                    <strong>Histoire de maladie:</strong> {{ patientHistoric.histoireMaladie }}
                  </p>
                  
                  <p *ngIf="pdfViewSettings.examenClinique[i] && patientHistoric.examenClinique">
                    <strong>Examen Clinique:</strong> {{ patientHistoric.examenClinique }}
                  </p>

                  <!-- Consultation -->
                  <div *ngIf="patientHistoric.hasConsultation">
                    <h5 class="label">Consultation</h5>
                    <ul>
                      <!-- Radiologies -->
                      <li *ngIf="pdfViewSettings.radioConsultation[i] && patientHistoric.consultationRadiologies.length">
                        <strong>Radiologies:</strong>
                        <ul>
                          <li *ngFor="let consultationRadiologie of patientHistoric.consultationRadiologies">
                            {{ consultationRadiologie.radio.nom_Radio }} - {{ consultationRadiologie.note_consultation_radio }}
                          </li>
                        </ul>
                      </li>

                      <!-- Biologies -->
                      <li *ngIf="pdfViewSettings.biologieConsultation[i] && patientHistoric.consultationBiologies.length">
                        <strong>Biologies:</strong>
                        <ul>
                          <li *ngFor="let consultationBiologie of patientHistoric.consultationBiologies">
                            {{ consultationBiologie.biology.element_Bio }} - {{ consultationBiologie.value }} - {{ consultationBiologie.note }}
                          </li>
                        </ul>
                      </li>

                      <!-- Actes -->
                      <li *ngIf="pdfViewSettings.actes[i] && patientHistoric.consultationActes.length > 0">
                        <strong>Actes:</strong>
                        <ul>
                          <li *ngFor="let consultationActe of patientHistoric.consultationActes">
                            {{ consultationActe.act.desc_Acte }}
                            <span *ngIf="doctor.dashboardPrintPayments">- {{ consultationActe.montant_consultation_acte }} DA</span>
                            - {{ consultationActe.note }}
                          </li>
                        </ul>
                      </li>

                      <!-- Vaccinations -->
                      <li *ngIf="pdfViewSettings.vaccin[i] && patientHistoric.consultationVaccinations.length">
                        <strong>Vaccins:</strong>
                        <ul>
                          <li *ngFor="let consultationVaccination of patientHistoric.consultationVaccinations">
                            {{ consultationVaccination?.prescription_consultation_vaccin?.nom_Vaccin }} - 
                            Lot: {{ consultationVaccination.numLot_consultation_vaccin }} - 
                            Date: {{ consultationVaccination.date_consultation_vaccin | date:'dd/MM/yyyy' }} - 
                            {{ consultationVaccination.note_consultation_vaccin }}
                          </li>
                        </ul>
                      </li>
                    </ul>
                  </div>

                  <!-- Lunette Ophtalmologie -->
                  <div *ngIf="doctor.speciality.label == 'Ophtalmologue' && pdfViewSettings.lunette[i]">
                    <h5 class="label">Lunette</h5>
                    <ul>
                      <li><strong>OD:</strong>
                        <ul>
                          <li>VL: {{patientHistoric.od_vl_avac_Sphere}} ({{patientHistoric.od_vl_avac_Cylindre}}) {{patientHistoric.od_vl_avac_Axe}}°</li>
                          <li>VP: {{patientHistoric.od_vp_avac_Sphere}} ({{patientHistoric.od_vp_avac_Cylindre}}) {{patientHistoric.od_vp_avac_Axe}}°</li>
                        </ul>
                      </li>
                      <li><strong>OG:</strong>
                        <ul>
                          <li>VL: {{patientHistoric.og_vl_avac_Sphere}} ({{patientHistoric.og_vl_avac_Cylindre}}) {{patientHistoric.og_vl_avac_Axe}}°</li>
                          <li>VP: {{patientHistoric.og_vp_avac_Sphere}} ({{patientHistoric.og_vp_avac_Cylindre}}) {{patientHistoric.og_vp_avac_Axe}}°</li>
                          <li>Add: {{patientHistoric.og_vp_avac_Addition}}</li>
                        </ul>
                      </li>
                      <li><strong>Note Lunette:</strong> {{patientHistoric.lunette_remarque}}</li>
                    </ul>
                  </div>

                  <!-- Lentille Ophtalmologie -->
                  <div *ngIf="doctor.speciality.label == 'Ophtalmologue' && pdfViewSettings.lentille[i]">
                    <h5 class="label">Lentille</h5>
                    <ul>
                      <li><strong>OG:</strong>
                        <ul>
                          <li>RC: {{patientHistoric.og_lentille_RC}}</li>
                          <li>DC: {{patientHistoric.og_lentille_DC}}</li>
                          <li>Puissance: {{patientHistoric.og_lentille_Puissance}}</li>
                        </ul>
                      </li>
                      <li><strong>OD:</strong>
                        <ul>
                          <li>RC: {{patientHistoric.od_lentille_RC}}</li>
                          <li>DC: {{patientHistoric.od_lentille_DC}}</li>
                          <li>Puissance: {{patientHistoric.od_lentille_Puissance}}</li>
                        </ul>
                      </li>
                      <li><strong>Note Lentille:</strong> {{patientHistoric.lentille_remarque}}</li>
                    </ul>
                  </div>

                  <!-- Paramètres Santé -->
                <!-- Paramètres Santé -->
<div *ngIf="pdfViewSettings.parametreSante[i] && patientHistoric.consultationParamSanteValues?.length">
  <h5 class="label">Paramètres Santé</h5>

  <ul>
    <li *ngFor="let consultationParamSante of patientHistoric.consultationParamSanteValues">

      <!-- Médecin non ophtalmologue -->
      <ng-container *ngIf="doctor.speciality.label !== 'Ophtalmologue'
        && consultationParamSante.value != null
        && consultationParamSante.value !== ''">

        <strong>{{consultationParamSante.parametre?.label}}:</strong>
        <span>{{consultationParamSante.value}}</span>
      </ng-container>

      <!-- Ophtalmologue -->
      <ng-container *ngIf="doctor.speciality.label === 'Ophtalmologue'
        && (consultationParamSante.value_OG != null || consultationParamSante.value_OD != null)">

        <strong>{{consultationParamSante.parametre?.label}}:</strong>

        <span *ngIf="consultationParamSante.value_OG != null">
          OG: {{consultationParamSante.value_OG}}
        </span>

        <span *ngIf="consultationParamSante.value_OD != null">
          OD: {{consultationParamSante.value_OD}}
        </span>
      </ng-container>

    </li>
  </ul>
</div>

                  <!-- Prescription -->
                  <div *ngIf="patientHistoric.hasPrescription">
                    <h5 class="label">Prescription</h5>
                    <ul>
                      <!-- Medications -->
                      <li *ngIf="pdfViewSettings.medics[i] && patientHistoric.prescriptionMedics.length">
                        <strong>Médications:</strong>
                        <ul>
                          <li *ngFor="let prescriptionMedic of patientHistoric.prescriptionMedics">
                            {{ prescriptionMedic.medic.nom }} - {{ prescriptionMedic.posology }} - {{ prescriptionMedic.duration }} - {{ prescriptionMedic.note }}
                          </li>
                        </ul>
                      </li>

                      <!-- Radiologies -->
                      <li *ngIf="pdfViewSettings.radioPres[i] && patientHistoric.prescriptionRadiologies.length">
                        <strong>Radiologies:</strong>
                        <ul>
                          <li *ngFor="let prescriptionRadiologie of patientHistoric.prescriptionRadiologies">
                            {{ prescriptionRadiologie.radio.nom_Radio }} - {{ prescriptionRadiologie.note }}
                          </li>
                        </ul>
                      </li>

                      <!-- Biologies -->
                      <li *ngIf="pdfViewSettings.biologiePresc[i] && patientHistoric.prescriptionBiologies.length">
                        <strong>Biologies:</strong>
                        <ul>
                          <li *ngFor="let prescriptionBiologie of patientHistoric.prescriptionBiologies">
                            {{ prescriptionBiologie.biology.element_Bio }} - {{ prescriptionBiologie.note }}
                          </li>
                        </ul>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </td>
        </tr>
      </tbody>
      <tfoot>
        <tr>
          <td>
            <div class="page-footer-space"></div>
          </td>
        </tr>
      </tfoot>
    </table>
    
    <div class="page-footer">
      <table class="table tableheader fixed-footer" cellspacing="0">
        <tr class="noborder">
          <td class="adresseFrFooter font">{{doctor.printArabicAddress}}</td>
        </tr>
        <tr class="noborder">
          <td class="adresseFrFooter font">{{doctor.printAddress}}</td>
        </tr>
        <tr class="noborder">
          <td class="adresseFrFooter font">Tél : {{doctor.fixPhone}}</td>
        </tr>
      </table>
    </div>
  </div>
</div>